export enum CheckboxVariant {
  OPTION = 'option',
  TILE = 'tile',
  IMAGE = 'image',
  PILL = 'pill',
}

export enum AnswerButtonVariant {
  OPTION = 'option',
  IMAGE = 'image',
}

export enum ListLayoutVariant {
  COLUMN = 'column',
  ROW = 'row',
  TILE = 'tile',
}
